/**
 * Check it is a mobile device or not.
 */
export function isMobileDevice() {
    var toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return toMatch.some(function (toMatchItem) { return navigator.userAgent.match(toMatchItem); });
}
